<template>
    <form class="g form">
        <slot></slot>
    </form>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">
    .g.form {
        
    }
</style>
